import React, {Component} from 'react';
import {WindowContext} from "./WindowContext";


class WindowProvider extends Component {

    constructor(props) {
        super(props);

        this.state = {
            width: window.innerWidth ? window.innerWidth : 1024,
            height: window.innerHeight ? window.innerHeight : 720,
            scrollY: 0,
            scrollStart: true,
            scrollEnd: false,
            scrollDirection: "down",
            gettingData: false,
            setGettingData: _bool => {
                this.setState({gettingData: _bool})
            }
        }

        this.handleResize = () => {
            const {width, height} = this.state;
            if (width !== window.innerWidth) {
                this.setWindowDims(window.innerWidth, window.innerHeight);
            } else if (Math.abs(window.innerHeight - height) > 100) {
                this.setWindowDims(window.innerWidth, window.innerHeight);
            }
        }

        this.setWindowDims = (width, height) => {
            this.setState({
                width: width,
                height: height
            });
        }

        this.handleScroll = (event) => {
            this.setState({
                scrollDirection: (this.state.scrollY < window.scrollY ? "down" : "up"),
                scrollY: window.scrollY,
                scrollStart: window.scrollY < 50,
                scrollEnd: ((window.innerHeight + window.scrollY) >= document.body.offsetHeight)
            });
        }

    }


    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        window.addEventListener("scroll", this.handleScroll);
    }


    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
        window.removeEventListener("scroll", this.handleScroll);
    }


    render() {
        return (
            <WindowContext.Provider value={this.state}>
                {this.props.children}
            </WindowContext.Provider>
        );
    }
}

export default WindowProvider;